import { store } from "@/store";
import { DateTime as TimeFormatter } from "luxon";
import sha1 from "js-sha1";

export const carStore = {
  namespaced: true,
  state: () => ({
    defaultVehicle: {},
    userSavedVehicles: [],
    defaultVehicleList: [],
    allCars: []
  }),
  getters: {
    getCarsArray: function(state) {
      let idPairs = {};
      state.allCars.map(item => {
        idPairs[item._id] = {
          make: item.make,
          model: item.model,
          is_default_car: item.is_default_car
        };
      });
      return idPairs;
    },

    getDefaultCarsPouchIdArray: function(state) {
      let idPairs = [];
      state.allCars.map(item => {
        if (item.is_default_car) {
          idPairs.push(item._id);
        }
      });
      return idPairs;
    },
    getUserSavedCarsPouchIdArray: function(state) {
      let idPairs = [];
      state.allCars.map(item => {
        if (!item.is_default_car) {
          idPairs.push(item._id);
        }
      });
      return idPairs;
    },

    getDefaultCarsList(state) {
      return state.allCars.filter(item => {
        return item.is_default_car;
      });
    },

    getUsersSavedCarsList(state) {
      return state.allCars.filter(item => {
        return !item.is_default_car;
      });
    },
    getDefaultCar() {
      let defaultV = store.getters["car/getDefaultCarsList"];
      return defaultV[defaultV.length - 1];
    }
  },
  mutations: {
    getUsersCars(state) {
      store.state.database
        .find({
          selector: {
            type: "vehicle",
            _id: { $exists: true },
            is_default_car: false
          },
          sort: ["_id"]
        })
        .then(result => {
          if (result.docs.length > 0) {
            state.userSavedVehicles = result.docs.reverse();
            console.log("got cars");
          }
        })
        .catch(function(err) {
          console.log(err);
          // store.commit("addVehicle", ["default", true])
        });
    },
    getCars(state) {
      store.state.database
        .find({
          selector: {
            type: "vehicle",
            _id: { $exists: true }
          },
          sort: ["_id"]
        })
        .then(result => {
          if (result.docs.length > 0) {
            state.allCars = result.docs.reverse();
          }
        })
        .catch(function(err) {
          console.log(err);
          // store.commit("addVehicle", ["default", true])
        });
    },
    defaultVehicle() {
      console.log("default vehicle");
      if (store.getters["car/getDefaultCarsList"].length < 1) {
        let Car = {
          _id: new Date().toISOString(),
          type: "vehicle",
          is_synced: false,
          make: "Car 1",
          model: "unknown",
          hash: sha1(new Date().toISOString() + Math.random()),
          registration_number: "00000",
          cost_price: 200.0,
          is_purchase: true,
          purchase_date: TimeFormatter.fromISO(
            new Date().toISOString()
          ).toFormat("y-MM-dd H:mm:s"),
          is_default_car: true,
          is_deleted: false,
          name: "default",
          time: TimeFormatter.fromISO(new Date().toISOString()).toFormat(
            "y-MM-dd H:mm:s"
          )
        };
        console.log(Car);
        store.commit("car/saveDefaultCar", Car);
      }
    },
    updateDefaultVehicle(state, updatedCar) {
      updatedCar["cost_price"] = "jj";
      // store.commit("car/saveDefaultCar", Car);
    },
    saveDefaultCar(state, formData) {
      store.state.database.put(formData, function callback(err) {
        if (err) {
          console.log("saving default car failed");
          return false;
        }
        store.commit("car/getCars");
      });
    },
    getDefaultCars(state) {
      store.state.database
        .find({
          selector: {
            type: "vehicle",
            _id: { $exists: true },
            is_default_car: true
          },
          sort: ["_id"]
        })
        .then(result => {
          if (result.docs.length > 0) {
            state.defaultVehicleList = result.docs.reverse();
            state.defaultVehicle = result.docs.reverse().pop();
            console.log("got default cars: ");
            console.log(state.defaultVehicleList);
          } else {
            store.commit("saveDefaultsIfNotPresent");
            console.log(result.docs);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  actions: {
    getAllCarsAction({ commit }) {
      commit("getCars");
    }
  }
};
